import { ID } from '@griply/types';

export const toggleIdInList = <Value extends ID>(
  list: Value[] | null | undefined,
  id: Value,
): Value[] => {
  const current = list ?? [];

  if (current.includes(id)) {
    return current.filter((existing) => existing !== id);
  }

  return [...current, id];
};
